
import Uploader from './src/Uploader.vue'
    
export default Uploader
